var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container loginLayout"},[(!_vm.user)?_c('div',[_c('br'),_c('br'),_vm._v(" "),_c('button',{staticClass:"loginBtn loginBtn--google",on:{"click":function($event){_vm.logUserInGoogle()}}},[_vm._v("\n          Login with Google\n        ")])]):_c('div',[_c('span',[_vm._v("Welcome "+_vm._s(_vm.user.displayName)+" ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-716aeb2d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 554
// module chunks = 1